<template>
  <el-dialog
    title="Change Password"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
  >
    <el-form
      :model="passwordForm"
      hide-required-asterisk
      label-width="32px"
      :rules="passwordRules"
      ref="passwordForm"
    >
      <el-form-item prop="oldPassword">
        <i slot="label" class="icon-label">
          <img src="../assets/img/personal-password.png" alt="" />
        </i>
        <el-input
          v-model.trim="passwordForm.oldPassword"
          autocomplete="off"
          placeholder="Please enter the original password"
          :type="oldPasswordVisible ? 'text' : 'password'"
          suffix-icon="null"
        ></el-input>
        <i
          class="pw-eye"
          :class="
            oldPasswordVisible
              ? 'iconfont icon-xiaoyanjing-zheng'
              : 'iconfont icon-xiaoyanjing-bi'
          "
          @click="oldPasswordVisible = !oldPasswordVisible"
        ></i>
      </el-form-item>
      <el-form-item prop="newPassword">
        <i slot="label" class="icon-label">
          <img src="../assets/img/personal-password.png" alt="" />
        </i>
        <el-input
          v-model.trim="passwordForm.newPassword"
          autocomplete="off"
          placeholder="Please enter a new password"
          :type="newPasswordVisible ? 'text' : 'password'"
          suffix-icon="null"
        ></el-input>
        <i
          class="pw-eye"
          :class="
            newPasswordVisible
              ? 'iconfont icon-xiaoyanjing-zheng'
              : 'iconfont icon-xiaoyanjing-bi'
          "
          @click="newPasswordVisible = !newPasswordVisible"
        ></i>
      </el-form-item>
      <el-form-item prop="checkPassword">
        <i slot="label" class="icon-label">
          <img src="../assets/img/personal-password.png" alt="" />
        </i>
        <el-input
          v-model.trim="passwordForm.checkPassword"
          autocomplete="off"
          placeholder="Please enter the new password again"
          :type="checkPasswordVisible ? 'text' : 'password'"
          suffix-icon="null"
        ></el-input>
        <i
          class="pw-eye"
          :class="
            checkPasswordVisible
              ? 'iconfont icon-xiaoyanjing-zheng'
              : 'iconfont icon-xiaoyanjing-bi'
          "
          @click="checkPasswordVisible = !checkPasswordVisible"
        ></i>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitPassword('passwordForm')">Confirm</el-button>
      <el-button @click="cancelSubmitPw">Cancel</el-button>
    </div>
  </el-dialog>
</template>
<script>
import validate from '@/utils/validate'
import { Message } from 'element-ui'
import http from '../utils/http'
export default {
  name: 'change-password-dialog',
  data () {
    return {
      dialogFormVisible: false,
      oldPasswordVisible: false,
      newPasswordVisible: false,
      checkPasswordVisible: false,
      passwordRules: {
        newPassword: [
          {
            validator: (rule, value, callback) => {
              let error = []
              let checkRes = validate.checkPassword(value)
              if (!checkRes.data) {
                error.push(checkRes.msg)
              }
              callback(error)
            },
            trigger: 'blur'
          },
          { required: true, trigger: 'blur' }
        ],
        checkPassword: [
          {
            validator: (rule, value, callback) => {
              let error = []
              if (value !== this.passwordForm.newPassword) {
                error.push('Inconsistent with the new password entered')
              }
              callback(error)
            },
            trigger: 'blur'
          },
          { required: true, message: ' ', trigger: 'blur' }
        ]
      },
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        checkPassword: ''
      }
    }
  },
  props: {
    username: ''
  },
  methods: {
    open () {
      // 修改密码框显示
      this.dialogFormVisible = true
    },
    submitPassword (form) {
      // 修改密码
      this.$refs[form].validate(async valid => {
        if (valid) {
          let { oldPassword, newPassword } = this.passwordForm
          oldPassword = this.$md5(oldPassword)
          newPassword = this.$md5(newPassword)
          await http.post(
            `/web/updateUserPassword?username=${this.username}&oldPassword=${oldPassword}&newPassword=${newPassword}`,
            {},
            res => {
              if (res.code === 200) {
                this.dialogFormVisible = false
                this.$refs[form].resetFields()
                this.$emit('signOut') // 跳回首页重新登录
              } else {
                Message.error(`${res.msg}`)
                this.dialogFormVisible = false
                this.$refs[form].resetFields()
              }
            }
          )
        }
      })
    },
    cancelSubmitPw () {
      // 取消修改密码按钮
      this.dialogFormVisible = false
      this.$refs['passwordForm'].resetFields()
    }
  }
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
  >>> .el-dialog {
    width: vw(480);
    background: #ffffff;
    box-shadow: -5px 0px 19px 0px rgba(4, 0, 0, 0.41);
    border-radius: 4px;
    .el-dialog__header {
      font-size: vw(18);
      color: #333333;
      font-weight: 600;
      .el-dialog__close:hover {
        color: $theme_color;
      }
    }
    .el-dialog__body {
      padding: 0 vw(50);
      .el-form {
        .el-form-item {
          border-bottom: 1px solid #dddddd;
          margin: vw(40) 0 0 0;
          display: relative;
          .el-form-item__label {
            padding: 0;
            height: 100%;
            text-align: left;
            .icon-label {
              display: inline-block;
              width: 100%;
              height: 100%;
              position: relative;
              img {
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-75%);
              }
            }
          }
          .el-form-item__content {
            .el-input {
              .el-input__inner {
                border: none;
              }
            }
            .pw-eye {
              position: absolute;
              top: 0;
              right: 7px;
              cursor: pointer;
              color: #999;
              font-size: vw(16);
            }
            .el-form-item__error {
              padding: vw(4) 0 0 vw(15);
            }
          }
          &.is-error {
            border-bottom: 1px solid red;
          }
        }
      }
    }
    .el-dialog__footer {
      margin: vw(80) 0 0;
      .dialog-footer {
        .el-button {
          width: vw(80);
          height: vw(34);
          border-radius: 2px;
          font-size: vw(16);
          color: #ffffff;
          border: none;
          border-radius: 2px;
          line-height: 0;
          padding: 0;
          &:focus {
            outline: 0;
          }
          &:first-child {
            background: $theme_color;
            &:hover {
              background: $theme_color-hover;
            }
          }
          &:last-child {
            background: #ffffff;
            border: 1px solid #999999;
            color: #999999;
            &:hover {
              border: 1px solid #ccc;
              color: #ccc;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/change-password-dialog.vue